import { api } from './client'

export function fetchCustomers() {
  return api.get('/customers').then((r) => r.data)
}

export function fetchCustomer(id) {
  return api.get(`/customers/${id}`).then((r) => r.data)
}

export function fetchCustomerSummary(id) {
  return api.get(`/customers/${id}/summary`).then((r) => r.data)
}

export function fetchCustomerAgents(id, params = {}) {
  const { page = 1, pageSize = 50, sortBy = 'hostname', sortDir = 'asc' } = params
  return api
    .get(`/customers/${id}/agents`, {
      params: {
        page,
        page_size: pageSize,
        sort_by: sortBy,
        sort_dir: sortDir,
      },
    })
    .then((r) => r.data)
}
